import { not } from "@insightfulscience/shared-utils/validation";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import apolloClient from "../apollo";
import signIn, { readAuthResult } from "../graphql/mutations/signIn";
import { Token, clearAll, RefreshToken } from "../persistent-storage";
import signUp, { packSignUpInput, readRegistrationResult } from "../graphql/mutations/signUp";
import { isTokenValid } from "../persistent-storage/token";
import gqlExchangeIdToken from "../graphql/mutations/gqlExchangeIdToken";
import signOut from "../graphql/mutations/signOut";

const setTokens = context => ({ token, refreshToken }) => {
	Token(context).set(token);
	RefreshToken(context).write(refreshToken, { expires: 365 });
};

export const login = ({ email, password }) =>
	apolloClient()
		.mutate({ mutation: signIn, variables: { email, password } })
		.then(readAuthResult)
		.then(setTokens());

export const logout = context =>
	Promise.resolve(RefreshToken(context).read())
		.then(
			refreshToken =>
				refreshToken == null ||
				apolloClient(context)
					.mutate({ mutation: signOut, variables: { refreshToken } })
					.then(({ data }) => data),
		)
		.finally(() => {
			apolloClient(context).stop();
			clearAll(context);
			apolloClient(context).resetStore();
		});

export const register = ({ firstName, lastName, company, email, password }) =>
	apolloClient()
		.mutate({
			mutation: signUp,
			variables: packSignUpInput({ firstName, lastName, company, email, password }),
		})
		.then(readRegistrationResult)
		.then(setTokens());

export const isAuthorized = context =>
	pipe(Token(context).get(), isTokenValid) && pipe(RefreshToken(context).read(), isTokenValid);

export const isNotAuthorized = not(isAuthorized);

export const exchangeIdToken = (context, issuerId, idToken) =>
	apolloClient(context)
		.mutate({ mutation: gqlExchangeIdToken, variables: { issuerId, idToken } })
		.then(({ data }) => data.exchangeToken)
		.then(setTokens(context));
